// **  Initial State
const initialState = {
	data: {},
	loading: false,
	messages: [
		{
			message: "Hi",
			time: "Mon Dec 10 2018 07:45:00 GMT+0000 (GMT)",
			senderId: 2,
			type: "text"
		}
	]
}

export const issuesReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'DASHBOARD_SET_INFO':
			return {
				...state,
				data: action.data
			}
		case 'ACTION_LOADING_START':
			return {
				...state, loading: true
			}
		case 'ACTION_LOADING_END':
			return {
				...state, loading: false
			}
		case 'ACTION_SET_MESSAGES':
			return {
				...state, messages: action.payload
			}
		case 'ACTION_ADD_MESSAGE':
			return {
				...state,
				messages: [
					...state.messages,
					action.payload
				]
			}
		default:
			return state
	}
}
